/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ActionPointDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getActionpoint = (signal?: AbortSignal) => {
  return customInstance<ActionPointDto[]>({
    url: `/actionpoint`,
    method: "GET",
    signal,
  });
};

export const getGetActionpointInfiniteQueryKey = () => {
  return ["infinite", `/actionpoint`] as const;
};

export const getGetActionpointQueryKey = () => {
  return [`/actionpoint`] as const;
};

export const getGetActionpointInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpoint>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getActionpoint>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActionpointInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionpoint>>> = ({
    signal,
  }) => getActionpoint(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getActionpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpoint>>
>;
export type GetActionpointInfiniteQueryError = void;

export function useGetActionpointInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpoint>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpoint>>,
          TError,
          Awaited<ReturnType<typeof getActionpoint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpoint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpoint>>,
          TError,
          Awaited<ReturnType<typeof getActionpoint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpoint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpoint>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetActionpointInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpoint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpoint>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActionpointQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionpoint>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getActionpoint>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionpointQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionpoint>>> = ({
    signal,
  }) => getActionpoint(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpoint>>
>;
export type GetActionpointQueryError = void;

export function useGetActionpoint<
  TData = Awaited<ReturnType<typeof getActionpoint>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionpoint>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpoint>>,
          TError,
          Awaited<ReturnType<typeof getActionpoint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpoint<
  TData = Awaited<ReturnType<typeof getActionpoint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionpoint>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpoint>>,
          TError,
          Awaited<ReturnType<typeof getActionpoint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpoint<
  TData = Awaited<ReturnType<typeof getActionpoint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionpoint>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetActionpoint<
  TData = Awaited<ReturnType<typeof getActionpoint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionpoint>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postActionpoint = (
  actionPointDto: ActionPointDto,
  signal?: AbortSignal,
) => {
  return customInstance<ActionPointDto>({
    url: `/actionpoint`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: actionPointDto,
    signal,
  });
};

export const getPostActionpointMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActionpoint>>,
    TError,
    { data: ActionPointDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActionpoint>>,
  TError,
  { data: ActionPointDto },
  TContext
> => {
  const mutationKey = ["postActionpoint"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActionpoint>>,
    { data: ActionPointDto }
  > = (props) => {
    const { data } = props ?? {};

    return postActionpoint(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActionpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActionpoint>>
>;
export type PostActionpointMutationBody = ActionPointDto;
export type PostActionpointMutationError = void;

/**
 * @summary Create
 */
export const usePostActionpoint = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postActionpoint>>,
      TError,
      { data: ActionPointDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postActionpoint>>,
  TError,
  { data: ActionPointDto },
  TContext
> => {
  const mutationOptions = getPostActionpointMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putActionpointId = (
  id: number,
  actionPointDto: ActionPointDto,
) => {
  return customInstance<ActionPointDto>({
    url: `/actionpoint/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: actionPointDto,
  });
};

export const getPutActionpointIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putActionpointId>>,
    TError,
    { id: number; data: ActionPointDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putActionpointId>>,
  TError,
  { id: number; data: ActionPointDto },
  TContext
> => {
  const mutationKey = ["putActionpointId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putActionpointId>>,
    { id: number; data: ActionPointDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putActionpointId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutActionpointIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putActionpointId>>
>;
export type PutActionpointIdMutationBody = ActionPointDto;
export type PutActionpointIdMutationError = void;

/**
 * @summary Update
 */
export const usePutActionpointId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putActionpointId>>,
      TError,
      { id: number; data: ActionPointDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putActionpointId>>,
  TError,
  { id: number; data: ActionPointDto },
  TContext
> => {
  const mutationOptions = getPutActionpointIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Id
 */
export const getActionpointId = (id: number, signal?: AbortSignal) => {
  return customInstance<ActionPointDto>({
    url: `/actionpoint/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetActionpointIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/actionpoint/${id}`] as const;
};

export const getGetActionpointIdQueryKey = (id?: number) => {
  return [`/actionpoint/${id}`] as const;
};

export const getGetActionpointIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActionpointIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionpointId>>
  > = ({ signal }) => getActionpointId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getActionpointId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpointId>>
>;
export type GetActionpointIdInfiniteQueryError = void;

export function useGetActionpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpointId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointId>>,
          TError,
          Awaited<ReturnType<typeof getActionpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointId>>,
          TError,
          Awaited<ReturnType<typeof getActionpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetActionpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getActionpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActionpointIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionpointIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionpointId>>
  > = ({ signal }) => getActionpointId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionpointId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpointId>>
>;
export type GetActionpointIdQueryError = void;

export function useGetActionpointId<
  TData = Awaited<ReturnType<typeof getActionpointId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointId>>,
          TError,
          Awaited<ReturnType<typeof getActionpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointId<
  TData = Awaited<ReturnType<typeof getActionpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointId>>,
          TError,
          Awaited<ReturnType<typeof getActionpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointId<
  TData = Awaited<ReturnType<typeof getActionpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetActionpointId<
  TData = Awaited<ReturnType<typeof getActionpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete By Id
 */
export const deleteActionpointId = (id: number) => {
  return customInstance<boolean>({
    url: `/actionpoint/${id}`,
    method: "DELETE",
  });
};

export const getDeleteActionpointIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionpointId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionpointId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteActionpointId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionpointId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteActionpointId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionpointIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionpointId>>
>;

export type DeleteActionpointIdMutationError = void;

/**
 * @summary Delete By Id
 */
export const useDeleteActionpointId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteActionpointId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionpointId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteActionpointIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Project Id
 */
export const getActionpointProjectIdProject = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<ActionPointDto[]>({
    url: `/actionpoint/${projectId}/project`,
    method: "GET",
    signal,
  });
};

export const getGetActionpointProjectIdProjectInfiniteQueryKey = (
  projectId?: number,
) => {
  return ["infinite", `/actionpoint/${projectId}/project`] as const;
};

export const getGetActionpointProjectIdProjectQueryKey = (
  projectId?: number,
) => {
  return [`/actionpoint/${projectId}/project`] as const;
};

export const getGetActionpointProjectIdProjectInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetActionpointProjectIdProjectInfiniteQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  > = ({ signal }) => getActionpointProjectIdProject(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointProjectIdProjectInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpointProjectIdProject>>
>;
export type GetActionpointProjectIdProjectInfiniteQueryError = void;

export function useGetActionpointProjectIdProjectInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
          TError,
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointProjectIdProjectInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
          TError,
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointProjectIdProjectInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Project Id
 */

export function useGetActionpointProjectIdProjectInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointProjectIdProjectInfiniteQueryOptions(
    projectId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActionpointProjectIdProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetActionpointProjectIdProjectQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>
  > = ({ signal }) => getActionpointProjectIdProject(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionpointProjectIdProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionpointProjectIdProject>>
>;
export type GetActionpointProjectIdProjectQueryError = void;

export function useGetActionpointProjectIdProject<
  TData = Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
          TError,
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointProjectIdProject<
  TData = Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
          TError,
          Awaited<ReturnType<typeof getActionpointProjectIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionpointProjectIdProject<
  TData = Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Project Id
 */

export function useGetActionpointProjectIdProject<
  TData = Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionpointProjectIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionpointProjectIdProjectQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
